import axios from "axios";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
    baseURL: `${BASE_URL}/api`,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
});

// Read a cookie by name (needed for CSRF double-submit)
function readCookie(name) {
    const parts = document.cookie ? document.cookie.split(";") : [];
    for (let p of parts) {
        p = p.trim();
        if (p.startsWith(name + "=")) return decodeURIComponent(p.slice(name.length + 1));
    }
    return null;
}

const MUTATION_METHODS = new Set(["post", "patch", "put", "delete"]);

// Attach X-Company-Id header from localStorage + X-CSRF-Token on every request
api.interceptors.request.use((config) => {
    const companyId = localStorage.getItem("ihpg_company_id");
    // Also send the "__all__" sentinel so super_admin endpoints that require
    // require_company_context can identify global mode instead of rejecting
    // the request with a "Header X-Company-Id mancante" error.
    if (companyId) {
        config.headers["X-Company-Id"] = companyId;
    }
    const method = (config.method || "get").toLowerCase();
    if (MUTATION_METHODS.has(method)) {
        const csrf = readCookie("ihpg_csrf");
        if (csrf) {
            config.headers["X-CSRF-Token"] = csrf;
        }
    }
    return config;
});

// 401 → redirect to login (but not for auth endpoints themselves)
api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            const path = err?.config?.url || "";
            if (!path.includes("/auth/login") && !path.includes("/auth/me")) {
                if (window.location.pathname !== "/login") {
                    window.location.href = "/login";
                }
            }
        }
        return Promise.reject(err);
    }
);

export default api;
